package com.eladfinish.bible.contest.analytics

import kotlinx.browser.window

// The GA4 web stream ("Bible Contest Web") of the Firebase app initialized in main.kt.
private const val MEASUREMENT_ID = "G-F19MM1TVQ4"

private val LOCAL_HOSTS = setOf("localhost", "127.0.0.1", "[::1]")

/**
 * Whether a page served from [hostname] is a visit worth counting. Development hosts are not:
 * the local machine, and Firebase Hosting preview channels (`<site>--<channel>-<hash>.web.app`).
 * Their traffic was most of what the web stream recorded (72 of 150 page views in a month).
 */
internal fun isAnalyticsHost(hostname: String): Boolean {
    val host = hostname.lowercase()
    return host.isNotEmpty() &&
        host !in LOCAL_HOSTS &&
        !host.endsWith(".localhost") &&
        "--" !in host
}

/**
 * Turns Google Analytics off for this page when it runs on a development host. Must run before
 * Firebase is initialized: the Firebase SDK sends `page_view`, `session_start` and `first_visit`
 * on its own, so skipping the app's `logEvent` calls would not be enough. `ga-disable-<id>` is the
 * switch gtag.js itself reads before sending anything (the one Firebase's
 * `setAnalyticsCollectionEnabled` sets, but only after its asynchronous initialization).
 */
fun disableAnalyticsOnDevelopmentHosts() {
    if (isAnalyticsHost(window.location.hostname)) return
    window.asDynamic()["ga-disable-$MEASUREMENT_ID"] = true
}
